import React from 'react';
import { Group, Paper, Text } from '@mantine/core';
import { IconUser, IconUsers, IconUsersGroup, IconHeart } from '@tabler/icons-react';

// Replaces the old 4-up grid of oversized stat cards (each drawing as much
// visual weight as real content, even when the value is 0) with a slim,
// low-emphasis chip row.
const STAT_DEFS = [
  { key: 'personas', label: 'personas', icon: IconUser },
  { key: 'friends', label: 'friends', icon: IconUsers },
  { key: 'groups', label: 'groups', icon: IconUsersGroup },
  { key: 'wishLists', label: 'wish lists', icon: IconHeart }
];

const DashboardStatStrip = ({ stats }) => (
  <Group gap="xs" wrap="wrap" mb="xl">
    {STAT_DEFS.map(({ key, label, icon: Icon }) => (
      <Paper
        key={key}
        withBorder
        radius="xl"
        px="sm"
        py={6}
        style={{ display: 'flex', alignItems: 'center', gap: 6 }}
      >
        <Icon size={14} stroke={1.75} style={{ opacity: 0.6 }} />
        <Text size="sm" fw={700}>{stats[key] ?? 0}</Text>
        <Text size="sm" c="dimmed">{label}</Text>
      </Paper>
    ))}
  </Group>
);

export default DashboardStatStrip;
